import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { TooltipProvider } from "./components/ui/tooltip";
import { ThemeProvider } from "./components/theme-provider";
import "./shared/i18n";
import { initialiseLaunchDarkly } from "./integrations/launch-darkly";

const root = ReactDOM.createRoot(document.getElementById("root")!);

const load = async () => {
  const LaunchDarklyProvider = await initialiseLaunchDarkly();

  root.render(
    <React.StrictMode>
      <LaunchDarklyProvider>
        <ThemeProvider>
          <TooltipProvider delayDuration={100}>
            <App />
          </TooltipProvider>
        </ThemeProvider>
      </LaunchDarklyProvider>
    </React.StrictMode>,
  );
};

load().then();
